import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class AudioHigher extends Icon {
  static defaultProps = {
    color: '#F8AC5B',
    size: 37,
    viewPortSize: 37
  };

  render() {
    let { strokeWidth, color, size, style, viewPortSize, className, ...props } = this.props;

    

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-1324.000000, -127.000000)">
            <g transform="translate(1325.000000, 128.000000)">
              <path
                d="M1.45571886e-16,17.3568204 L8.83131951e-16,29.2979765 L8.04265817,21.3157895 L33.4051746,21.3157895 C34.2850016,21.3157895 35,20.5984831 35,19.7136408 L35,1.60214866 C35,0.709214461 34.2859724,0 33.4051746,0 L1.59482539,0 C0.714998385,0 0,0.71730639 0,1.60214866 L0,17.3568204 Z"
                stroke={color}
                strokeWidth={strokeWidth||"0.8"}
              />
              <path
                d="M23.5673844,9.96491228 L20.4430782,9.96491228 C20.1311481,9.96491228 19.8863636,10.2162612 19.8863636,10.5263158 C19.8863636,10.8273026 20.1356133,11.0877193 20.4430782,11.0877193 L23.5673844,11.0877193 L23.5673844,14.2120254 C23.5673844,14.5239555 23.8187333,14.76874 24.1287879,14.76874 C24.4297747,14.76874 24.6901914,14.5194904 24.6901914,14.2120254 L24.6901914,11.0877193 L27.8144975,11.0877193 C28.1264276,11.0877193 28.3712121,10.8363704 28.3712121,10.5263158 C28.3712121,10.2253289 28.1219625,9.96491228 27.8144975,9.96491228 L24.6901914,9.96491228 L24.6901914,6.84060615 C24.6901914,6.52867605 24.4388425,6.28389155 24.1287879,6.28389155 C23.827801,6.28389155 23.5673844,6.53314117 23.5673844,6.84060615 L23.5673844,9.96491228 Z"
                fill={color}
              />
              <path
                d="M5.56818182,7.67942584 C5.56818182,7.36232455 5.82552552,7.10526316 6.13291209,7.10526316 L11.3670879,7.10526316 C11.6789798,7.10526316 11.9318182,7.37159839 11.9318182,7.67942584 C11.9318182,7.99652713 11.6744745,8.25358852 11.3670879,8.25358852 L6.13291209,8.25358852 C5.82102017,8.25358852 5.56818182,7.98725329 5.56818182,7.67942584 Z M5.56818182,10.2631579 C5.56818182,9.9460566 5.83284378,9.68899522 6.14025311,9.68899522 L12.950656,9.68899522 C13.2666022,9.68899522 13.5227273,9.95533044 13.5227273,10.2631579 C13.5227273,10.5802592 13.2580653,10.8373206 12.950656,10.8373206 L6.14025311,10.8373206 C5.82430686,10.8373206 5.56818182,10.5709853 5.56818182,10.2631579 Z M5.56818182,12.84689 C5.56818182,12.5297887 5.82297765,12.2727273 6.14193853,12.2727273 L12.153516,12.2727273 C12.4703931,12.2727273 12.7272727,12.5390625 12.7272727,12.84689 C12.7272727,13.1639912 12.4724769,13.4210526 12.153516,13.4210526 L6.14193853,13.4210526 C5.82506145,13.4210526 5.56818182,13.1547174 5.56818182,12.84689 Z"
                fill={color}
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Note.js